import React from "react";
import './AppHeader.css';
import HeaderLogo from './images/ff-header-logo.png';
import LoginLogoutButton from "./LoginLogoutButton";
import { Link } from "react-router-dom";

const AppHeader = ({ children, wallets, setWallets }) => {
    return (
        <header className="App-header">
            <div className="mobile-blocker">Sorry, mobile is not supported at this time.</div>
            <Link to="/"><img className="ff-logo" src={HeaderLogo} alt="Future Fest Logo" /></Link>
            {children}
            <LoginLogoutButton wallets={wallets} setWallets={setWallets} />
        </header>
    );
};

export default AppHeader;
